export { default as ModuleProvider } from './moduleProvider';
export { default as moduleProviderFactory } from './moduleProviderFactory';
export { default as menuProvider } from './menuProvider';
export { default as routeProvider } from './routeProvider';
export { default as storeProvider } from './storeProvider';



// WEBPACK FOOTER //
// ./src/core/providers/index.js